import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { ROUTES } from "../../utils/api"
import { SONG_TYPES } from "../../utils/types"
import ChooseSong from "./Components/ChooseSong"
import MenuWithContent from "../../assets/components/MenuWithContent"
import { Container, Grid, Stack } from "@mui/material"
import CategorySelector from "./Components/CategorySelector"
import { useChangeCurrentLocation } from "../../hooks/contexts/currentLocationContext"
import SearchBar from "../../assets/components/SearchBar"
import RouteButton from "../../assets/components/RouteButton"
import { GraphicEq, Lyrics, MusicNote } from "@mui/icons-material"
import { useIsSmallScreen } from "../../hooks/useIsSmallScreen"

import { useContext } from "react"
import { PolyglotContext } from "../../polyglot/polyGlotContext"

const Library = () => {
    const { polyglot } = useContext(PolyglotContext)

    const navigate = useNavigate()
    const curPath = useLocation().pathname
    const [songType, setSongType] = useState<SONG_TYPES | undefined>(undefined)
    const [category, setCategory] = useState<string | undefined>(undefined)
    const [searchValue, setSearchValue] = useState<string | undefined>(undefined)
    const isSmallScreen = useIsSmallScreen()

    const changeCurrentLocation = useChangeCurrentLocation()

    useEffect(() => {
        if (curPath === ROUTES.LIBRARY.MAIN) {
            // Default subpage in library page
            navigate(ROUTES.LIBRARY.MUSIC.fullPath, { replace: true })
        } else if (curPath === ROUTES.LIBRARY.SOUNDBANKS.fullPath) {
            setSongType(SONG_TYPES.SOUNDBANKS)
        } else if (curPath === ROUTES.LIBRARY.MUSIC.fullPath) {
            setSongType(SONG_TYPES.MUSIC)
        } else if (curPath === ROUTES.LIBRARY.KEY.fullPath) {
            setSongType(SONG_TYPES.KEY)
        }
    }, [curPath])

    useEffect(() => {
        setCategory(undefined)
        changeCurrentLocation(polyglot.t("components.navbar.libraryRouteBtn"))
    }, [songType, changeCurrentLocation])

    let displayedSearchTerm: string = polyglot.t("library.libraryComponent.searchTermMusic")
    if (songType === SONG_TYPES.MUSIC) {
        displayedSearchTerm = polyglot.t("library.libraryComponent.searchTermMusic")
    }
    if (songType === SONG_TYPES.SOUNDBANKS) {
        displayedSearchTerm = polyglot.t("library.libraryComponent.searchTermSoundscapes")
    }
    if (songType === SONG_TYPES.KEY) {
        displayedSearchTerm = polyglot.t("library.libraryComponent.searchTermKeys")
    }

    return (
        <MenuWithContent
            showCurrentlyPlaying
            menuItems={
                isSmallScreen && (
                    <>
                        <RouteButton title={polyglot.t("library.libraryComponent.musicRouteBtn")} route={ROUTES.LIBRARY.MUSIC.fullPath} icon={MusicNote} />
                        <RouteButton title={polyglot.t("library.libraryComponent.soundscapesRouteBtn")} route={ROUTES.LIBRARY.SOUNDBANKS.fullPath} icon={GraphicEq} />
                        <RouteButton title={polyglot.t("library.libraryComponent.keysRouteBtn")} route={ROUTES.LIBRARY.KEY.fullPath} icon={Lyrics} />
                    </>
                )
            }
            content={
                <>
                    <Container
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            height: "80vh",
                            width: isSmallScreen ? "100vw" : "80vw",
                        }}
                    >
                        {songType && (
                            <Stack sx={{ maxWidth: "md", height: "100%" }}>
                                <Grid item sx={{ width: "100%" }}>
                                    <SearchBar placeholder={polyglot.t("library.libraryComponent.searchbarPlaceholder", { displayedSearchTerm: displayedSearchTerm })} setSearchValue={setSearchValue} />
                                </Grid>
                                <Grid item sx={{ width: "100%", pt: 1, px: 1 }}>
                                    <CategorySelector type={songType} category={category} setCategory={setCategory} />
                                </Grid>
                                <Grid item xs sx={{ pt: 3 }}>
                                    <ChooseSong type={songType} category={category} searchValue={searchValue} />
                                </Grid>
                            </Stack>
                        )}
                    </Container>
                </>
            }
        />
    )
}

export default Library
